import styled, { css } from 'styled-components';
export const Value = styled.p `
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400);
  letter-spacing: var(--font-letter-spacing-normal);
  color: inherit;
`;
export const Icon = styled.svg `
  width: 16px;
  height: 10px;
  display: flex;
  align-items: center;
  fill: inherit;
`;
export const Container = styled.div `
  display: flex;
  align-items: center;
  gap: 5px;
  min-height: var(--font-line-height-400);

  ${({ $type }) => $type === 'positive' &&
    css `
      color: var(--text-success);
      svg {
        fill: var(--bg-success);
        transform: rotate(180deg);
      }
    `}

  ${({ $type }) => $type === 'negative' &&
    css `
      color: var(--text-critical);
      svg {
        fill: var(--bg-critical);
      }
    `}

  ${({ $type }) => $type === 'neutral' &&
    css `
      color: var(--text-secondary);
      svg {
        fill: var(--text-secondary);
      }
    `}

  ${({ size }) => size === 'small' &&
    css `
      ${Icon} {
        width: 12px;
        height: 8px;
      }

      ${Value} {
        font-size: var(--font-size-300);
        line-height: var(--font-line-height-300); /* 142.857% */
        letter-spacing: var(--font-letter-spacing-loose);
      }
    `}
`;
